<template>
  <div class="flex-row toolbar-workbook-button-dropdown" ref="dropdownToobarWorkbook">
    <div class="header-item__toolbar" v-tooltip="propsData.toolTip" @click="toggleMenu">
      <div :class="propsData.icon"></div>
      <div class="icon24 down-group size-icon_custom"></div>
    </div>
    <div class="list_data-toolbar" v-show="isShowList">
      <div
        class="item_toolbar d-flex"
        v-for="itemToolbar in propsData.menuItems"
        :key="itemToolbar.text"
        @click="menuClick(itemToolbar)"
      >
        <div :class="itemToolbar.icon" class="icon_item"></div>
        <div class="text_item">{{ itemToolbar.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, onBeforeUnmount} from 'vue';
export default {
  name: 'toolbarItemButtonDropdown',
  props: {
    /**
     * Đối tượng toolbar
     */
    propsData: {
      type: Object,
      default: {},
    },
    /**
     * style của range đang focus
     */
    rangeStyle: {
      type: Object,
      default: {},
    },
  },
  emits: ['toolbarEvent'],
  setup(props, {emit}) {
    const isShowList = ref(false);
    const dropdownToobarWorkbook = ref(null);
    /**
     * Hàm trả style ra ngoài
     * TMNghia 30/03/2024
     */
    const menuClick = item => {
      emit('toolbarEvent', null, 'click', {toolbar: props.propsData, value: item});
      isShowList.value = false;
    };    

    const toggleMenu = () => {
      isShowList.value = !isShowList.value;
    };

    const handleClickOutside = event => {
      if (dropdownToobarWorkbook.value && !dropdownToobarWorkbook.value.contains(event.target)) {
        isShowList.value = false;
      }
    };
    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      menuClick,
      isShowList,
      toggleMenu,
      dropdownToobarWorkbook,
    };
  },
  mounted() {
    document.addEventListener('click', this.click_out);
  },
};
</script>

<style lang="scss">
.toolbar-workbook-button-dropdown {
  .header-item__toolbar {
    display: flex;
    height: 32px;
    width: 32px;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .size-icon_custom{
      margin-left: 5px;
    }
  }
  .list_data-toolbar {
    top: 32px;
    right: 0;
    width: 130px;
    position: absolute;
    z-index: 9999;
    background-color: white;
    box-shadow: 0 0 8px 6px rgba(0, 0, 0, 0.16);
    .item_toolbar {
      height: 28px;
      white-space: nowrap;
      outline: none;
      color: inherit;
      text-decoration: none;
      line-height: 28px;
      height: 28px;
      cursor: pointer;
      padding: 0 16px 0 6px !important;
      transition: all 0.7s ease;
      .icon_item {
        margin-right: 8px;
      }
    }
    .item_toolbar:hover {
      outline: 0;
      background-color: #e3e6e7;
      border-radius: 2px;
      color: #303133;
      transition: all 0.2s ease;
    }
  }
}
</style>